export const errorEN = {
  no_data: 'No data',
  failed_to_add_task: 'Failed to add task',
  failed_to_edit_task: 'Failed to edit task',
} as const;
